<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="true"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="enterpriseColor"
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{$t('common.addItem')}}
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <!-- <v-list-item-avatar>
              <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John">
            </v-list-item-avatar> -->

            <v-list-item-content>
              <v-list-item-title>{{$t('poll.selectType')}}</v-list-item-title>
              <!-- <v-list-item-subtitle>Founder of Vuetify.js</v-list-item-subtitle> -->
            </v-list-item-content>

            <!-- <v-list-item-action>
              <v-btn
                :class="fav ? 'red--text' : ''"
                icon
                @click="fav = !fav"
              >
                <v-icon>mdi-heart</v-icon>
              </v-btn>
            </v-list-item-action> -->
          </v-list-item>
        </v-list>

        <v-divider />

        <v-list>
          <v-list-item>
            <!-- <v-list-item-action>
              <v-switch v-model="message" color="purple"></v-switch>
            </v-list-item-action> -->
            <v-list-item-title>
              <v-btn
                block
                @click="onAddItem('multiSelection')"
              >
                {{$t('poll.multiSelection')}}
              </v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <!-- <v-list-item-action>
              <v-switch v-model="message" color="purple"></v-switch>
            </v-list-item-action> -->
            <v-list-item-title>
              <v-btn
                block
                @click="onAddItem('singleSelection')"
              >
                {{$t('poll.singleSelection')}}
              </v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <v-btn
                block
                @click="onAddItem('rating')"
              >
                {{$t('poll.rating')}}
              </v-btn>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <v-btn
                block
                @click="onAddItem('number')"
              >
                {{$t('poll.number')}}
              </v-btn>
            </v-list-item-title>
          </v-list-item>

          <!-- <v-list-item>
            <v-list-item-action>
              <v-switch v-model="hints" color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable hints</v-list-item-title>
          </v-list-item> -->
        </v-list>

        <!-- <v-card-actions>
          <v-spacer />

          <v-btn text @click="menu = false">Cancel</v-btn>
          <v-btn color="primary" text @click="menu = false">Save</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  export default {
    props: {
      onAddItem: {
        type: Function,
        required: true
      }
    },
    data: () => ({
      fav: true,
      menu: false,
      message: false,
      hints: true,
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
  }
</script>
